import Link from "next/link";
import { Box, Heading, Paragraph, Anchor, Card, CardBody } from "grommet";
import Image from "next/legacy/image";
import styled from "styled-components";
import Info from "./info";

const StyledParagraph = styled(Paragraph)`
  overflow: hidden;
  max-height: 120px;
  -webkit-box-orient: vertical;
  font-weight: normal;
  display: block;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 5;
`;

export default function Teaser(article) {
  const { id, title, description, cover } = article;

  return (
    <Link href={`/blog/${id}`} passHref legacyBehavior>
      <Anchor data-ga={`articleTeaser::click::${id}`}>
        <Card as="section" elevation="none" border round="xsmall" height="100%">
          <CardBody flex={false} height="initial">
            <Image
              alt={title}
              layout="intrinsic"
              objectFit="cover"
              width={200}
              height={160}
              src={cover}
            />
          </CardBody>
          <Box pad={"medium"} responsive={false} flex>
            <Heading level="2" size="22px" margin="none">
              {title}
            </Heading>
            <StyledParagraph
              margin={{ top: "small", bottom: "none" }}
              color="status-disabled"
            >
              {description}
            </StyledParagraph>
            <Info
              article={article}
              flex
              justify="end"
              margin={{ top: "medium" }}
            />
          </Box>
        </Card>
      </Anchor>
    </Link>
  );
}
